import {
    EventType,
    EventSubType,
    EventKind,
    EnhancedMetric,
    RetentionEnhancedMetric,
    WebAnalyticsMetric,
    AgenticEventKind,
} from '@/types/analytics/event.types';
import { common as c } from '@pendo/aggregations';

export const CORE_EVENT = 'core';

export const PAGE_EVENT: EventType = 'page';

export const FEATURE_EVENT: EventType = 'feature';

export const TRACK_TYPE_EVENT: EventType = 'trackType';

export const PROMPT_EVENT: EventType = 'prompt';

const EVENT_TYPES: Record<EventType, Record<EventSubType, string>> = {
    feature: {
        source: 'feature',
        sourceId: 'featureId',
        eventName: 'featureClicks',
        eventType: 'featureEvents',
        requestType: 'Feature',
    },
    page: {
        source: 'page',
        sourceId: 'pageId',
        eventName: 'pageViews',
        eventType: 'pageEvents',
        requestType: 'Page',
    },
    trackType: {
        source: 'trackType',
        sourceId: 'trackTypeId',
        eventName: 'trackEvents',
        eventType: 'trackEvents',
        requestType: 'TrackType',
    },
    prompt: {
        source: 'prompt',
        sourceId: 'promptId',
        eventName: 'promptEvents',
        eventType: 'promptEvents',
        requestType: 'Prompt',
    },
};

export const AGENTIC_EVENT_KINDS = ($t: (key: string) => string): Readonly<Record<AgenticEventKind, string>> => {
    return {
        prompt: $t('Prompts'),
    };
};

export const EVENT_KINDS = ($t: (key: string) => string): Readonly<c.OptionalRecord<EventKind, string>> => {
    return {
        eventCount: $t('Events'),
        eventTime: '',
        pageViews: $t('Page views'),
        featureClicks: $t('Feature clicks'),
        trackEvents: $t('Track Events'),
        visitor: $t('Visitors'),
        account: $t('Accounts'),
        parentAccount: $t('Parent Accounts'),
    };
};

export const FRUSTRATION_KINDS = ($t: (key: string) => string): Readonly<c.OptionalRecord<EventKind, string>> => {
    return {
        rageClicks: $t('Rage clicks'),
        deadClicks: $t('Dead clicks'),
        errorClicks: $t('Error clicks'),
        uTurns: $t('U-turns'),
    };
};

export const WEB_ANALYTICS_CHART_KINDS: Readonly<Record<WebAnalyticsMetric, string>> = {
    conversions: 'Conversions',
    conversionRate: 'Conversion rate',
    sessions: 'Sessions',
    avgSessionTime: 'Average session time',
    traffic: 'Traffic',
    newTraffic: 'New traffic',
    avgSessionsPerUser: 'Average sessions per visitor',
    avgTime: 'Average time on app',
};

export const RETENTION_ENHANCED_METRICS = (
    $t: (key: string) => string,
): Readonly<Record<RetentionEnhancedMetric, string>> => {
    return {
        visitorAcquisition: $t('Visitor acquisition'),
        accountAcquisition: $t('Account acquisition'),
        allVisitorRetention: $t('All visitor retention'),
        allAccountRetention: $t('All account retention'),
        newVisitorRetention: $t('New visitor retention'),
        newAccountRetention: $t('New account retention'),
    };
};

export const ENHANCED_METRICS = ($t: (key: string) => string): Readonly<Record<EnhancedMetric, string>> => {
    return {
        averageTime: $t('Average time on Page'),
        visitorAdoption: $t('Visitor adoption'),
        accountAdoption: $t('Account adoption'),
    };
};

export const EVENT_CHART_CONFIG_TYPE: Readonly<Record<
    EventKind | AgenticEventKind | EnhancedMetric | RetentionEnhancedMetric,
    string
>> = {
    eventCount: 'perWeekChart',
    eventTime: 'perWeekChart',
    pageViews: 'perWeekChart',
    featureClicks: 'perWeekChart',
    trackEvents: 'perWeekChart',
    visitor: 'perWeekChart',
    account: 'perWeekChart',
    parentAccount: 'perWeekChart',
    averageTime: 'perWeekChart',
    prompt: 'perWeekChart',
    errorClicks: 'perWeekChart',
    deadClicks: 'perWeekChart',
    rageClicks: 'perWeekChart',
    uTurns: 'perWeekChart',
    visitorAdoption: 'perWeekChartAdoption',
    accountAdoption: 'perWeekChartAdoption',
    visitorAcquisition: 'perWeekChartRetention',
    accountAcquisition: 'perWeekChartRetention',
    allVisitorRetention: 'perWeekChartRetention',
    allAccountRetention: 'perWeekChartRetention',
    newVisitorRetention: 'perWeekChartRetention',
    newAccountRetention: 'perWeekChartRetention',
};

export default EVENT_TYPES;
